import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { QRSalesSlip } from '@/apis/vescajs'

export const QrCodeSalesSlip: React.FC<{ receipt: QRSalesSlip }> = ({ receipt }) => {
  const { t } = useTranslation()
  return (
    <div css={componentStyle}>
      <div className="sales-slip-block">
        <div className="title">
          {t('salesSlipInfo.title')}&emsp;{t('salesSlipInfo.customerCopy')}
        </div>
        <div className="section">
          <span className="label">{t('salesSlipInfo.date')}</span>
          <span>{receipt.transactionAt}</span>
        </div>

        <div className="section">
          <span className="label">{t('salesSlipInfo.slipNumber')}</span>
          <span>{receipt.slipNumber}</span>
        </div>

        <div className="section">
          <span className="label">{t('salesSlipInfo.transactionNumber')}</span>
          <span>{receipt.transactionNumber}</span>
        </div>
      </div>
      <hr className="-block" />
    </div>
  )
}
const componentStyle = css({
  '.sales-slip-block': {
    margin: '0 32px',
    fontSize: 24,
    '.title': { textAlign: 'center', fontWeight: 'bold', paddingBottom: '1em' },
    '.section': { display: 'flex', justifyContent: 'space-between' },
  },
  hr: {
    '&.-block': {
      borderTop: '4px dashed #A3A3A3',
      margin: '40px 0',
    },
  },
})
